<template>
  <div class="flex flex-col justify-between flex-grow">
    <div class="flex-grow min-h-[600px] p-6">
      <slot></slot>
    </div>
  </div>
</template>
